<template>
  <book :id="$route.params.repoId.split('-').pop()" />
</template>

<script>
import Book from "@/components/Book.vue";

export default {
  name: "BookPage",
  components: {
    Book
  }
};
</script>
